// use-theme.ts — Sprint 019: Executive Theme Engine™
// React hook for consuming the active theme.
// Components call useTheme() to get the current themeId and setTheme().

import { useContext } from 'react';
import { ThemeContext } from '@/components/theme-provider';

export function useTheme() {
  return useContext(ThemeContext);
}
